import secureAxios from '../secure_axios';

const baseUrl = 'modelo-item-formulario'

async function servGetModelosItemFormularioPorBloco(blocoItemId) {
    const response = await secureAxios.get(`${baseUrl}/por-bloco`, {
        params: { blocoItemId }
    })
    return response.data
}

export {
    servGetModelosItemFormularioPorBloco
}